import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getMe, login as apiLogin, logout as apiLogout } from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('veriplan_token'));
  const [loading, setLoading] = useState(Boolean(token));

  const clearSession = useCallback(() => {
    localStorage.removeItem('veriplan_token');
    setToken(null);
    setUser(null);
  }, []);

  useEffect(() => {
    const loadUser = async () => {
      if (!token) return;
      try {
        const me = await getMe(token);
        setUser(me);
      } catch (err) {
        clearSession();
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [token, clearSession]);

  const login = async (email, mot_de_passe) => {
    const result = await apiLogin(email, mot_de_passe);
    const { token: newToken, user: userInfo } = result;
    localStorage.setItem('veriplan_token', newToken);
    setToken(newToken);
    setUser(userInfo);
    return result;
  };

  const logout = async () => {
    try {
      if (token) {
        await apiLogout(token);
      }
    } finally {
      clearSession();
    }
  };

  const value = { user, token, login, logout, clearSession, loading };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}
